module.exports = __webpack_public_path__ + "img/add.bae0fac3.svg";